import { Link } from "react-router-dom";
import { Users, Building2, Palette, Gauge, ScrollText, Plug, Settings2 } from "lucide-react";

const LINKS = [
    { to: "/admin/users", label: "Users", desc: "Invite people and set roles", icon: Users },
    { to: "/admin/organisation", label: "Organisation", desc: "Name, defaults and limits", icon: Building2 },
    { to: "/admin/branding", label: "Branding", desc: "Logo and colours", icon: Palette },
    { to: "/admin/usage", label: "Usage", desc: "Spend and limits", icon: Gauge },
    { to: "/admin/audit-log", label: "Audit log", desc: "Who changed what", icon: ScrollText },
    { to: "/admin/integrations", label: "API keys", desc: "Connect your providers", icon: Plug },
    { to: "/admin/ai-settings", label: "AI settings", desc: "Models and behaviour", icon: Settings2 },
];

export default function SettingsHub() {
    return (
        <div data-testid="settings-page" className="space-y-6">
            <h1 className="text-3xl font-medium tracking-tight text-neutral-900">Settings</h1>
            <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
                {LINKS.map(({ to, label, desc, icon: Icon }) => (
                    <Link key={to} to={to} data-testid={`settings-link-${label.toLowerCase().replace(/\s+/g, "-")}`} className="flex items-start gap-3 rounded-lg border border-neutral-200 bg-white p-4 hover:border-neutral-400">
                        <Icon size={18} className="mt-0.5 text-neutral-500" />
                        <div>
                            <div className="text-sm font-medium text-neutral-900">{label}</div>
                            <div className="text-xs text-neutral-500">{desc}</div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
